import { Routes } from '@angular/router';

import { AuthResolver } from './core/resolvers/auth.resolver';
import { QuoteResolver } from './core/resolvers/quote.resolver';
import { redirectWhileKeepingQueryParams } from './shared/functions/redirect-while-keeping-query-params';

export const routes: Routes = [
	{
		path: 'login',
		loadChildren: () => import('./features/login/login.routes'),
		resolve: { quote: QuoteResolver },
	},
	{
		path: 'privacy-policy',
		loadChildren: () => import('./features/privacy-policy/privacy-policy.routes'),
		resolve: { quote: QuoteResolver },
	},
	{
		path: 'quote/quick',
		pathMatch: 'full',
		redirectTo: redirectWhileKeepingQueryParams('quick'),
	},
	{
		path: 'short-urls',
		loadChildren: () => import('./features/short-url/short-url.routes'),
	},
	{
		path: 'authenticate',
		loadChildren: () => import('./features/authenticate/authenticate.routes'),
	},
	{
		path: 'portal',
		loadChildren: () => import('./features/portal/portal.routes'),
		resolve: { auth: AuthResolver, quote: QuoteResolver },
	},
	{
		path: 'email-sent-log',
		loadChildren: () => import('./features/email-sent-log/email-sent-log.routes'),
	},
	{
		path: 'unsubscribe',
		loadChildren: () => import('./features/unsubscribe/unsubscribe.routes'),
	},
	{
		path: '',
		loadChildren: () => import('./features/quote/quote.routes'),
		resolve: { quote: QuoteResolver },
	},
	{
		path: '**',
		pathMatch: 'full',
		redirectTo: '',
	},
];
